import React, { useState } from "react";
import Lightbox from "react-image-lightbox"; // Ensure this library is installed
import "react-image-lightbox/style.css"; // Lightbox CSS

const ImageGalleryComponent = ({ totalImages }) => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [galleryOpen, setGalleryOpen] = useState(false);

  if (!totalImages || totalImages.length === 0) return null; // Handle empty images case

  const setImagePhotoIndex = (index) => {
    setGalleryOpen(true);
    setPhotoIndex(index);
  };

  return (
    <div className="row h-100 p-3">
      {/* Main Image */}
      <div className="col-12 col-md-6" onClick={() => setImagePhotoIndex(0)}>
        <img
          src={totalImages[0]}
          className="w-100 h-100 cursor-pointer"
          alt="Main Image"
          style={{ maxHeight: 400 }}
        />
      </div>

      {/* Additional Images */}
      {totalImages.length > 1 && (
        <div className="col-12 col-md-6 d-flex flex-wrap">
          {totalImages.slice(1, 5).map((image, index) => (
            <div
              key={index}
              className="col-6"
              onClick={() => setImagePhotoIndex(index + 1)}
            >
              {index === 3 ? (
                <div
                  className="card text-white w-100 h-100 cursor-pointer"
                  onClick={() => setGalleryOpen(true)}
                >
                  <img
                    src={image}
                    className="w-100 h-100 cursor-pointer ps-1 pt-1"
                    alt={`Additional Image ${index + 1}`}
                    style={{ maxHeight: 200 }}
                  />
                  {totalImages.length > 5 && (
                    <div className="card-img-overlay d-flex justify-content-center align-items-center bg-dark bg-opacity-50 m-0 ms-1 my-1 ps-1 pt-1">
                      <p className="text-center h5 m-0 text-white">
                        +{totalImages.length - 5} Photos
                      </p>
                    </div>
                  )}
                </div>
              ) : (
                <img
                  src={image}
                  className={`w-100 h-100 cursor-pointer ${
                    index === 0
                      ? "pe-1 pb-1"
                      : index === 1
                      ? "ps-1 pb-1"
                      : index === 2
                      ? "pe-1 pt-1"
                      : ""
                  }`}
                  style={{ maxHeight: 200 }}
                  alt={`Additional Image ${index + 1}`}
                />
              )}
            </div>
          ))}
        </div>
      )}

      {/* Lightbox Modal */}
      {galleryOpen && (
        <Lightbox
          mainSrc={totalImages[photoIndex]}
          nextSrc={totalImages[(photoIndex + 1) % totalImages.length]}
          prevSrc={
            totalImages[
              (photoIndex + totalImages.length - 1) % totalImages.length
            ]
          }
          onCloseRequest={() => setGalleryOpen(false)}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + totalImages.length - 1) % totalImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % totalImages.length)
          }
          wrapperClassName="ImageModal"
        />
      )}
    </div>
  );
};

export default ImageGalleryComponent;
